import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-707f9e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "AI小答")
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }

import {routes} from "@/router/routes";
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import {useLoginUserStore} from "@/store/userStore"
import message from "@arco-design/web-vue/es/message";
import { Avatar } from "@arco-design/web-vue";
import checkAccess from "@/access/checkAccess";
import {userLogoutUsingPost} from "@/api/userController";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

//@表示从src目录下引入
const loginUserStore = useLoginUserStore();
//useRouter:控制页面的跳转
const router = useRouter();
// 当前选中的菜单项
const selectedKeys = ref(["/"]);
// 路由跳转之后，自动更新选中的菜单项   afterEach方法是路由跳转之后自动执行的  to:跳转到的路由  from：从哪个路由跳转的  failure：失败
router.afterEach((to, from, failure) => {
  //将高亮显示在当前选中的菜单项
  selectedKeys.value = [to.path];
});

// 展示在菜单栏的路由数组
const visibleRoutes = computed(() => {
  //将routes中的路由过滤一遍，根据meta中hideInMenu的值进行过滤
  return routes.filter((item) => {
    //item.meta?加个？代表 meta后面的hideInMenu可有可没有
    if (item.meta?.hideInMenu) {
      return false;
    }
    // 根据权限过滤菜单
    if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    return true;
  });
});

// 点击菜单跳转到对应页面  key：当前选中的菜单项 而这个key读取的就是<a-menu-item v-for="item in visibleRoutes" :key="item.path">中的:key的值
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};
//<!--    TODO 第二次修改-->
const logout = async () => {
  const res = await userLogoutUsingPost();
  if (res.data.code === 0) {
    message.success("退出成功");
  } else {
    message.error("退出失败，" + res.data.message);
  }
  //刷新页面的函数
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "200px" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (_unref(loginUserStore).loginUser.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_unref(loginUserStore).loginUser.userName ?? "匿名用户") + " ", 1),
                    _createVNode(_unref(Avatar), null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _unref(loginUserStore).loginUser.userAvatar,
                          alt: "avatar"
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_popconfirm, {
                      content: "是否登出",
                      position: "bottom",
                      type: "warning",
                      onOk: logout
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { class: "button" }, {
                          default: _withCtx(() => [
                            _createTextVNode("登出")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_a_button, {
                      href: "/user/login",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登录")
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})